import React from 'react';
import AdminUsers from './AdminUsers';

function Users() {
  return <AdminUsers />;
}

export default Users;
